import { Inject, Injectable } from '@angular/core';
import {
  FILTERS_CACHE_SERVICE_TOKEN,
  FiltersCacheObject,
  PipelineFiltersCacheService,
} from './pipeline-filters-cache.service';
import { oneResultFromEach } from '@vendasta/rx-utils';
import { Observable } from 'rxjs';
import { PIPELINE_SERVICE_INJECTION_TOKEN, PipelineServiceInterface } from '../pipeline/pipeline-service.interface';

@Injectable()
export class PipelineFilterSaverService {
  savedFilters$: Observable<FiltersCacheObject[]>;

  constructor(
    @Inject(FILTERS_CACHE_SERVICE_TOKEN) private readonly pipelineFiltersCacheService: PipelineFiltersCacheService,
    @Inject(PIPELINE_SERVICE_INJECTION_TOKEN) private readonly pipelineService: PipelineServiceInterface,
  ) {
    this.savedFilters$ = pipelineFiltersCacheService.filtersCache$;
  }

  async saveCurrentFilters(groupName: string): Promise<Error> {
    return Promise.all(
      oneResultFromEach([
        this.pipelineService.selectedUIFilters$,
        this.pipelineService.sort$,
        this.pipelineService.lastSearchTerm$,
      ]),
    ).then(([filters, sort, search]) => {
      return this.pipelineFiltersCacheService.saveNewFilterInCache(filters, sort, search, groupName);
    });
  }

  deleteFilterGroup(groupName: string): Promise<Error> {
    return this.pipelineFiltersCacheService.removeSavedFilterFromCache(groupName);
  }
}
